/* eslint-disable import/prefer-default-export */

export const DELIVERY_STATUS_OPTIONS = [
  'delivery_pending',
  'delivery_in_transit',
  'delivery_delivered',
  'delivery_not_delivered'
];

export const DELIVERY_STATUSES_WITH_ATTACHMENT = [
  'delivery_in_transit',
  'delivery_delivered'
];

export const DELIVERY_STATUS_STYLES = {
  delivery_pending: '!tw-bg-yellow-50 !tw-text-yellow-700',
  delivery_in_transit: '!tw-bg-blue-50 !tw-text-blue-700',
  delivery_delivered: '!tw-bg-green-50 !tw-text-green-700',
  delivery_not_delivered: '!tw-bg-red-50 !tw-text-red-700'
};

export const DELIVERY_STATUS_CSS_CLASS = {
  delivery_pending: 'pending',
  delivery_in_transit: 'in-transit',
  delivery_delivered: 'delivered',
  delivery_not_delivered: 'not-delivered'
};
